import { render, staticRenderFns } from "./HighAlarm.vue?vue&type=template&id=5d88a621&scoped=true&"
import script from "./HighAlarm.vue?vue&type=script&lang=js&"
export * from "./HighAlarm.vue?vue&type=script&lang=js&"
import style0 from "./HighAlarm.vue?vue&type=style&index=0&id=5d88a621&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88a621",
  null
  
)

export default component.exports